import { render, staticRenderFns } from "./MyRequestLayout.vue?vue&type=template&id=211a5b12"
import script from "./MyRequestLayout.vue?vue&type=script&lang=ts"
export * from "./MyRequestLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports